/* Действия «Наград» (bot-rewards.js, раздел 5): забрать день серии, нажатие по заданию, смена вкладки, прокрутка к партнёрскому блоку, сторис.
   Состояние меняется через store.update — React перерисовывает только то, что сменилось. */
import { DAYS, TABS, type TabKey, type Task } from './data';
import { getRt } from './runtime';
import { uiText } from '../../i18n';
import { srvClaim, srvStory } from './rewards-server';

const rt = () => getRt();
const $ = (id: string) => document.getElementById(id);

/** Забрать награду за сегодня: день отмечается галочкой (кружок выскакивает), счётчик серии растёт, кнопка становится «Завтра +N C».
    С сервером — начисление сервера; отметка и счётчик меняются по его новому снимку */
export function claimDay(btn?: HTMLElement) {
  const { store, ui } = rt();
  const S = store.S;
  if (S.today) return;
  if (S.srv) return void srvClaim(null, btn);
  const amt = DAYS[S.streak];
  store.update(s => {
    s.today = true;
    s.streak = Math.min(s.streak + 1, DAYS.length);
  });
  ui.spend(-amt);
  ui.buzz();
}

/** Прокрутить к партнёрскому блоку (smooth — плавно): блок встаёт под верхний край страницы; без плавности растворение под липкой шапкой ставится сразу */
export function toPt(o?: { smooth?: boolean }) {
  const { BC } = rt();
  const p = $('rwPt');
  const root = $('rewards');
  if (!p || !root) return;
  const top = root.scrollTop + p.getBoundingClientRect().top - root.getBoundingClientRect().top - 12;
  if (o?.smooth) root.scrollTo({ top, behavior: BC.smooth() });
  else {
    root.scrollTop = top;
    BC.sticky.sync(root);
  }
}

/** Сторис из задания: общий лист (BotCore.story); после отправки задание можно забрать. Telegram не сообщает, вышла ли сторис — засчитывается отправка */
export function storyOpen() {
  const r = rt();
  r.BC.story.open({
    onShared() {
      if (r.store.S.pg.story) return;
      if (r.mounted) r.popAfter.set('story', '.rw-take');
      r.store.update(s => void (s.pg.story = 1));
      r.ui.buzz();
    },
  });
}

/** Нажатие по заданию: выполнено — забрать награду; не выполнено — туда, где задание делается */
export function taskTap(t: Task, el: HTMLElement) {
  const r = rt();
  const { c, ui, BC } = r;
  const st = c.stOf(t);
  if (el.dataset.tipb) return;
  if (t.sv) return srvTap(t, el);
  if (st === 'claim') {
    r.popAfter.set(t.id, '.st-pr');
    r.store.update(s => void s.got.add(t.id));
    ui.spend(-t.r);
    ui.buzz();
    return;
  }
  if (st !== 'todo') return;
  if (t.go === 'story') return storyOpen();
  if (t.go === 'sid') {
    ui.buzz();
    BC.sid.link(el);
    return;
  }
  if (t.go === 'ref') {
    ui.buzz();
    toPt({ smooth: true });
    return;
  }
  if (t.go === 'circle') ui.openApp({ src: 'char' });
  else if (t.go === 'screen') ui.openApp(t.o || {});
  else if (t.go === 'studio' || t.go === 'clone' || t.go === 'tts' || t.go === 'history') ui.go(t.go);
}

/** Задание с сервера: «Забрать» — начисление сервера, иначе туда, где задание делается (адрес раздела от сервера) */
function srvTap(t: Task, el: HTMLElement) {
  const { ui, BC } = rt();
  const sv = t.sv!;
  if (sv.st === 'claim') return void srvClaim(t.id, el);
  if (sv.st !== 'todo') return;
  if (sv.off) return ui.tip(el, uiText(sv.off));
  ui.buzz();
  if (t.go === 'story') return srvStory(t);
  if (t.go === 'sid') return BC.sid.link(el);
  if (t.go === 'ref') return toPt({ smooth: true });
  if (t.go === 'chat') return addToGroup(el);
  if (!sv.route) return ui.tip(el, uiText('Это задание выполняется вне мини-приложения'));
  if ('go' in sv.route) ui.go(sv.route.go);
  else ui.openApp(sv.route.app);
}

/** «Бот в чате» [ТЕЛЕГРАМ]: выбор группы через ссылку startgroup; засчитывает бот, когда его добавят (docs/64 §5) */
function addToGroup(el: HTMLElement) {
  const { ui, BC } = rt();
  const tg = (window as unknown as { Telegram?: { WebApp?: { initData?: string; openTelegramLink?: (url: string) => void } } }).Telegram?.WebApp;
  if (!tg?.initData || typeof tg.openTelegramLink !== 'function') return ui.tip(el, BC.TIPS.addChat);
  tg.openTelegramLink('https://' + BC.tme({ group: 'rewards' }));
}

/** Прокрутка, при которой шапка вкладок только прилипает; вверх до целого пикселя */
function stuckY(): number | null {
  const hd = $('rwHd');
  const sec = $('rwTk');
  const root = $('rewards');
  if (!hd || !sec || !root) return null;
  const rt0 = root.getBoundingClientRect().top;
  const nat = root.scrollTop + sec.getBoundingClientRect().top - rt0 + (parseFloat(getComputedStyle(hd).marginTop) || 0);
  return Math.max(0, Math.ceil(nat - (hd.getBoundingClientRect().top - rt0)));
}

/** Сменить вкладку: бегунок переезжает сразу, вкладки уходят и появляются (run → swap). Шапка прилипла — новая вкладка начинается сразу под ней:
    прокрутка встаёт туда, где шапка только прилипает (в середине смены, пока вкладки скрыты) */
export function setTab(k: TabKey, run: (after: () => void) => void) {
  const r = rt();
  if (k === r.store.S.tab || !TABS.some(x => x[0] === k)) return;
  r.store.update(s => void (s.tab = k));
  const hd = $('rwHd');
  const y = hd && r.BC.sticky.on(hd) ? stuckY() : null;
  run(() => {
    const root = $('rewards');
    if (y != null && root && root.scrollTop > y) {
      root.scrollTop = y;
      r.BC.sticky.sync(root);
    }
  });
  r.ui.buzz();
}
